import React from "react";

const HRDVCommercialUses = ({ title, description, cargoTypes }) => {
  return (
    <section className="hrdv-uses-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4">
          {cargoTypes.map((cargo, i) => (
            <div
              key={i}
              className="col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="hrdv-uses-card">
                <h3>{cargo.title}</h3>
                <p>{cargo.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HRDVCommercialUses;
